webpackJsonp([79611799117203,60335399758886],{

/***/ 118:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(209);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(118);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(497)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(52);
	
	var _raf = __webpack_require__(502);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _utils = __webpack_require__(75);
	
	__webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint no-return-assign: off */
	/* eslint no-param-reassign: off */
	var easeInOutCubic = function easeInOutCubic(t, b, c, d) {
	  var cc = c - b;
	  t /= d / 2;
	  if (t < 1) {
	    return cc / 2 * t * t * t + b;
	  }
	  return cc / 2 * ((t -= 2) * t * t + 2) + b;
	};
	
	var VISIBILITY_HEIGHT = 400;
	
	/* eslint class-methods-use-this: off */
	
	var BackTop = function (_Component) {
	  _inherits(BackTop, _Component);
	
	  function BackTop() {
	    _classCallCheck(this, BackTop);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      visible: false
	    };
	
	    _this.handleScroll = function () {
	      var scrollTop = (0, _utils.getScrollTop)();
	      _this.setState({
	        visible: scrollTop > VISIBILITY_HEIGHT
	      });
	    };
	
	    _this.scrollToTop = _this.scrollToTop.bind(_this);
	    return _this;
	  }
	
	  BackTop.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll);
	    this.handleScroll();
	  };
	
	  BackTop.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll);
	  };
	
	  BackTop.prototype.setScrollTop = function setScrollTop(value) {
	    document.body.scrollTop = value;
	    document.documentElement.scrollTop = value;
	  };
	
	  BackTop.prototype.scrollToTop = function scrollToTop() {
	    var _this2 = this;
	
	    var scrollTop = (0, _utils.getScrollTop)();
	    var startTime = Date.now();
	    var frameFunc = function frameFunc() {
	      var timestamp = Date.now();
	      var time = timestamp - startTime;
	      _this2.setScrollTop(easeInOutCubic(time, scrollTop, 0, 450));
	      if (time < 450) {
	        (0, _raf2.default)(frameFunc);
	      }
	    };
	    (0, _raf2.default)(frameFunc);
	  };
	
	  BackTop.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactTransitionGroup.CSSTransition,
	      {
	        "in": this.state.visible,
	        classNames: "back-top-fade",
	        timeout: {
	          enter: 200,
	          exit: 150
	        },
	        mountOnEnter: true,
	        unmountOnExit: true
	      },
	      _react2.default.createElement(
	        "button",
	        { className: "back-top", onClick: this.scrollToTop },
	        "Back to top"
	      )
	    );
	  };
	
	  return BackTop;
	}(_react.Component);
	
	exports.default = BackTop;
	module.exports = exports["default"];

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BackTop = __webpack_require__(201);
	
	var _BackTop2 = _interopRequireDefault(_BackTop);
	
	var _ProfileLinks = __webpack_require__(206);
	
	var _ProfileLinks2 = _interopRequireDefault(_ProfileLinks);
	
	__webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var config = this.props.config;
	    var copyright = config.copyright;
	
	    if (!copyright) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "footer",
	      { className: "footer" },
	      _react2.default.createElement(
	        "div",
	        { className: "footer-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "footer-back-top" },
	          _react2.default.createElement(_BackTop2.default, null)
	        ),
	        _react2.default.createElement(_ProfileLinks2.default, { config: config }),
	        _react2.default.createElement(
	          "p",
	          { className: "copyright" },
	          copyright
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileLinks = function (_Component) {
	  _inherits(ProfileLinks, _Component);
	
	  function ProfileLinks() {
	    _classCallCheck(this, ProfileLinks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProfileLinks.prototype.createLinks = function createLinks() {
	    var profileLinks = this.props.config.profileLinks;
	
	    return profileLinks.map(function (item) {
	      return _react2.default.createElement(
	        'li',
	        { key: item.name, className: 'profile-' + item.name },
	        _react2.default.createElement(
	          'a',
	          { href: item.url, target: '_blank', rel: 'noopener noreferrer' },
	          _react2.default.createElement('i', { className: item.iconClass })
	        )
	      );
	    });
	  };
	
	  ProfileLinks.prototype.render = function render() {
	    return _react2.default.createElement(
	      'ul',
	      { className: 'profile-links' },
	      this.createLinks()
	    );
	  };
	
	  return ProfileLinks;
	}(_react.Component);
	
	ProfileLinks.propTypes = {
	  config: _propTypes2.default.object.isRequired
	};
	exports.default = ProfileLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(204);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainLayout = function (_React$Component) {
	  _inherits(MainLayout, _React$Component);
	
	  function MainLayout() {
	    _classCallCheck(this, MainLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainLayout.prototype.getLocalTitle = function getLocalTitle() {
	    function capitalize(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    }
	    var pathPrefix = _SiteConfig2.default.pathPrefix ? _SiteConfig2.default.pathPrefix : '/';
	    var currentPath = this.props.location.pathname.replace(pathPrefix, '').replace('/', '');
	    var title = '';
	    if (currentPath === '') {
	      title = 'Home';
	    } else if (currentPath === 'tags/') {
	      title = 'Tags';
	    } else if (currentPath === 'categories/') {
	      title = 'Categories';
	    } else if (currentPath === 'about/') {
	      title = 'About';
	    } else if (currentPath.indexOf('posts')) {
	      title = 'Article';
	    } else if (currentPath.indexOf('tags/')) {
	      var tag = currentPath.replace('tags/', '').replace('/', '').replace('-', ' ');
	      title = 'Tagged in ' + capitalize(tag);
	    } else if (currentPath.indexOf('categories/')) {
	      var category = currentPath.replace('categories/', '').replace('/', '').replace('-', ' ');
	      title = '' + capitalize(category);
	    }
	    return title;
	  };
	
	  MainLayout.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          _SiteConfig2.default.siteTitle + ' | ' + this.getLocalTitle()
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: _SiteConfig2.default.siteDescription })
	      ),
	      children(),
	      _react2.default.createElement(_Footer2.default, { config: _SiteConfig2.default })
	    );
	  };
	
	  return MainLayout;
	}(_react2.default.Component);
	
	exports.default = MainLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-6338ea68d53ad620d2c5.js